import { INIT_EMAIL, INIT_MOBILE } from '../constants';

const serviceIdMessags = (url: string): string | undefined => {
  if (url === INIT_EMAIL) {
    return 'برای حفظ امنیت، تا ۲۴ ساعت بعد از تغییر ایمیل، امکان برداشت از کیف پول وجود نخواهد داشت.';
  }
  if (url === INIT_MOBILE) {
    return 'برای حفظ امنیت، تا ۲۴ ساعت بعد از تغییر شماره همراه، امکان برداشت از کیف پول وجود نخواهد داشت.';
  }
  return undefined;
};

export default serviceIdMessags;
